<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* 管理员端所有表格内容与表头统一居中 */
#app .el-table {
  margin-left: auto;
  margin-right: auto;
}

#app .el-table th.el-table__cell,
#app .el-table td.el-table__cell {
  text-align: center !important;
}

#app .el-table th.el-table__cell .cell,
#app .el-table td.el-table__cell .cell {
  text-align: center !important;
  justify-content: center;
}
</style>